module.exports = __webpack_public_path__ + "img/table.94897594.svg";